import { CountriesResponse, ModalitiesResponse, RegionsResponse } from '@/types/misc'
import { defineStore } from 'pinia'

interface States {
  countries: Ref<CountriesResponse | null>
  regions: Ref<RegionsResponse | null>
  modalities: Ref<ModalitiesResponse | null>
}

export const useMiscStore = defineStore('misc', () => {
  const states: States = {
    countries: ref(null),
    regions: ref(null),
    modalities: ref(null),
  }

  const resetStore = () => {
    states.countries.value = null
    states.regions.value = null
    states.modalities.value = null
  }

  return {
    ...states,
    resetStore,
  }
})
